import React from 'react';
import Index from "./routes/index";
import Root from "./routes/root";
import ErrorPage from './error-page'
import './App.css'


import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";

const router = createBrowserRouter([
  {
    path: "/",
    element: <Root />,
    errorElement: <ErrorPage />,
    children: [
      { index: true, element: <Index /> },
    ],
  },
]);


function App() {
  
  return (
    <RouterProvider router={router} />
  );
}

export default App;
